// Plug necessary events between new and legacy scripts
import events from "/events";
import store from "/store";

events.on("authenticate_data_ready", config => {
  store.dispatch("setup", config);
  events.emitNoLegacy("setup:ready", config);
  events.emitNoLegacy("abtest:ready", config.test_categories);
});
